/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, UrlTree, createUrlTreeFromSnapshot } from '@angular/router';
import { getAllRouteParams } from '@app/common/utils/router';
import { ClusterId } from '@shared/types/cluster';
import { MenuClusterActionsService } from '../menu-cluster-actions/menu-cluster-actions.service';

export const dialogCcConnectionSettingsGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot): true | UrlTree => {
  const { contextActionClusterId } = getAllRouteParams<{ contextActionClusterId: ClusterId }>(route);
  const menuService = inject(MenuClusterActionsService);
  const redirectTo = createUrlTreeFromSnapshot(route, ['..']);
  return contextActionClusterId && menuService.areCcConnectionSettingsVisible(contextActionClusterId)()
    ? true
    : redirectTo;
};
